/*
  KNAKRD nudges (PDP LAB 20 Sep 2026). Every line here is true from live data, stated once, quietly.
  1. Dispatch counter: "Ships today · order within 1h 40m" against the 2pm Sydney cut-off,
     then "Ships tomorrow" / "Ships Monday". Minutes only, never seconds. Updates once a minute.
  2. Set nudge on the product page follows the chosen colour and size.
  3. Low-stock line on cards follows the chosen colour (data comes with the card).
*/
(() => {
  /* ---- 1. dispatch ---- */
  const SYD = 'Australia/Sydney';
  const CUTOFF = 14 * 60; // 2pm
  const fmt = new Intl.DateTimeFormat('en-AU', { timeZone: SYD, weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false });
  const sydney = () => {
    const parts = Object.fromEntries(fmt.formatToParts(new Date()).map((p) => [p.type, p.value]));
    return { day: parts.weekday, mins: (parseInt(parts.hour, 10) % 24) * 60 + parseInt(parts.minute, 10) };
  };
  const dispatchText = () => {
    const { day, mins } = sydney();
    const weekday = !['Sat', 'Sun'].includes(day);
    if (weekday && mins < CUTOFF) {
      const left = CUTOFF - mins;
      const h = Math.floor(left / 60), m = left % 60;
      const within = h ? `${h}h ${String(m).padStart(2, '0')}m` : `${m} min`;
      return `Ships today · order within ${within}`;
    }
    if (day === 'Fri' || day === 'Sat' || day === 'Sun') return 'Ships Monday · order by 2pm Sydney';
    return 'Ships tomorrow · order by 2pm Sydney';
  };
  const paintDispatch = () => {
    const t = dispatchText();
    document.querySelectorAll('[data-kn-dispatch]').forEach((el) => { if (el.textContent !== t) el.textContent = t; });
  };
  const start = () => {
    paintDispatch();
    setInterval(paintDispatch, 60 * 1000);
    // the cart drawer is re-rendered from a fetch after every add, so repaint its line then
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(() => paintDispatch()).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', paintDispatch);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();

  /* ---- 2. set nudge follows the variant ---- */
  const paintSet = (el, colour, size) => {
    let D; try { D = JSON.parse(el.querySelector('[data-kn-setnudge-data]').textContent); } catch (e) { return; }
    const inColour = D.variants.filter((v) => v.colour === colour);
    const exact = inColour.find((v) => v.size === size && v.av) || inColour.find((v) => v.av);
    const link = el.querySelector('[data-kn-setnudge-link]');
    if (!inColour.length || !inColour.some((v) => v.av)) { el.hidden = true; return; }
    el.hidden = false;
    link.href = exact ? `${D.url}?variant=${exact.id}` : D.url;
    link.textContent = `See the set in ${colour}`;
  };
  const initSets = () => {
    document.querySelectorAll('[data-kn-setnudge]:not([data-kn-armed])').forEach((el) => {
      el.dataset.knArmed = '1';
      paintSet(el, el.dataset.colour, el.dataset.size);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data?.variant || data.sectionId !== el.dataset.section) return;
          const cIdx = parseInt(el.dataset.colourIdx, 10), sIdx = parseInt(el.dataset.sizeIdx, 10);
          const opts = [data.variant.option1, data.variant.option2, data.variant.option3];
          paintSet(el, cIdx >= 0 ? opts[cIdx] : '', sIdx >= 0 ? opts[sIdx] : '');
        });
      }
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initSets) : initSets();
  document.addEventListener('shopify:section:load', initSets);
})();
